import { Injectable, inject } from '@angular/core';
import { ConfigurationService } from '@sc/data-access-configuration';
import { CLIENT_APP_ID, Fitter } from '@sc/data-access-models';
import { Observable } from 'rxjs';
import {
  FitterNameDisplayContext,
  FitterNameDisplayDefaultKeys,
} from '../models';
import { FITTER_NAME_DISPLAY_CONTEXT } from '../tokens';
import { ContextualDisplayService } from './contextual-display.service';

@Injectable()
export class FitterNameDisplayService extends ContextualDisplayService<FitterNameDisplayDefaultKeys> {
  private readonly configService = inject(ConfigurationService);
  private readonly clientAppId = inject(CLIENT_APP_ID);
  private readonly displayContext =
    inject(FITTER_NAME_DISPLAY_CONTEXT, { optional: true }) ||
    FitterNameDisplayDefaultKeys.ContextualDefaultValue;

  constructor() {
    super(
      ['GlobalApplicativeConstants', 'fitterNamingStrategy'],
      FitterNameDisplayDefaultKeys.ClientAppDefaultValue,
      FitterNameDisplayDefaultKeys.ContextualDefaultValue,
      FitterNameDisplayDefaultKeys.BrandDefaultValue
    );
  }

  getFitterNameKey(
    fitter: Partial<Fitter>,
    overrideContext?: FitterNameDisplayContext
  ): Observable<string> {
    return this.getContextualKey(
      this.clientAppId || FitterNameDisplayDefaultKeys.ClientAppDefaultValue,
      overrideContext ||
        this.displayContext ||
        FitterNameDisplayDefaultKeys.ContextualDefaultValue,
      fitter.brandId || FitterNameDisplayDefaultKeys.BrandDefaultValue
    );
  }

  getInstantFitterNameKey(
    fitter: Partial<Fitter>,
    overrideContext?: FitterNameDisplayContext
  ): string {
    return this.getInstantContextualKey(
      this.clientAppId || FitterNameDisplayDefaultKeys.ClientAppDefaultValue,
      overrideContext ||
        this.displayContext ||
        FitterNameDisplayDefaultKeys.ContextualDefaultValue,
      fitter.brandId || FitterNameDisplayDefaultKeys.BrandDefaultValue
    );
  }

  getFitterNameTranslation(
    fitter: Partial<Fitter>,
    overrideContext?: FitterNameDisplayContext,
    interpolateParams?: any
  ): Observable<any> {
    return this.getContextualTranslation(
      [
        this.clientAppId || FitterNameDisplayDefaultKeys.ClientAppDefaultValue,
        overrideContext ||
          this.displayContext ||
          FitterNameDisplayDefaultKeys.ContextualDefaultValue,
        fitter?.brandId || FitterNameDisplayDefaultKeys.BrandDefaultValue,
      ],
      {
        brandName: this.configService.getBrandName(fitter?.brandId || ''),
        ...fitter,
        ...interpolateParams,
        cleanBrandName: fitter?.brand?.replace(/^PAC - /, ''),
      }
    );
  }

  getInstantFitterNameTranslation(
    fitter: Partial<Fitter>,
    overrideContext?: FitterNameDisplayContext,
    interpolateParams?: any
  ): any {
    return this.getInstantContextualTranslation(
      [
        this.clientAppId || FitterNameDisplayDefaultKeys.ClientAppDefaultValue,
        overrideContext ||
          this.displayContext ||
          FitterNameDisplayDefaultKeys.ContextualDefaultValue,
        fitter.brandId || FitterNameDisplayDefaultKeys.BrandDefaultValue,
      ],
      {
        brandName: this.configService.getBrandName(fitter.brandId || ''),
        ...fitter,
        ...interpolateParams,
      }
    );
  }
}
